import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { scroller } from 'react-scroll';
import { getScreenBreakpoint } from '../../helpers/screen';
import Icon from '../Icon';
import PrimaryButton from '../_generic/button/PrimaryButton';

const LocationPin = ({ deal, scrollTarget, theme }) => {
  if (isEmpty(deal?.destination)) {
    return null;
  }

  return (
    <>
      <div className="location-pin-container">
        <PrimaryButton
          className="outline primary-color capitalize fit-content align-left italic font-weight-normal"
          onClick={() => {
            if (scrollTarget) {
              const breakpoint = getScreenBreakpoint();
              scroller.scrollTo(scrollTarget, {
                delay: 100,
                duration: 1_000,
                offset: breakpoint === 'sm' ? -300 : 0,
                smooth: true,
              });
            }
          }}
          style={{ borderWidth: 1, fontSize: 14 }}
        >
          <Icon
            align="0px"
            faIcon={faMapMarkerAlt}
            padding={'0px 5px 0px 0px;'}
          />{' '}
          {deal?.destination}
        </PrimaryButton>
      </div>
      <style jsx>{`
        .location-pin-container {
          padding: 0px 0px 5px 0px;
        }

        @media (max-width: ${theme.breakpoints.smDown}) {
          :global(.location-pin-container .primary-button) {
            border: 0px !important;
            padding: 0px !important;
            display: block;
          }
        }
      `}</style>
    </>
  );
};

LocationPin.propTypes = {
  deal: PropTypes.object.isRequired,
  scrollTarget: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

export default LocationPin;
